// extracted by mini-css-extract-plugin
module.exports = {"terms":"SectionTerms_terms__7tJTU","container":"SectionTerms_container__rmePY"};